import script from "./redeem-gift-card.vue?vue&type=script&setup=true&lang=js"
export * from "./redeem-gift-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__